import type { ChangeEvent, MouseEvent } from 'react';

import { TablePagination } from '@mui/material';
import { useRecoilState, useRecoilValue } from 'recoil';

import { countState, pageSizeState, pageState } from '../../../state/incidentTable/pagination';

export const Pagination = () => {
  const [pageSize, setPageSize] = useRecoilState(pageSizeState);
  const [page, setPage] = useRecoilState(pageState);
  const count = useRecoilValue(countState);

  const handleChangePage = (_: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(1);
  };

  return (
    <TablePagination
      sx={{ borderTop: '1px solid #e2e2e2' }}
      component='div'
      showFirstButton
      showLastButton
      count={count}
      page={page - 1}
      onPageChange={handleChangePage}
      rowsPerPage={pageSize}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
};

export default Pagination;
